export default __webpack_public_path__ + "static/media/img_03.680d8225.svg";